import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
    BASE_CLASSES_FIGURE,
    BASE_CLASSES_IMAGE,
    WHITE_FONT_CLASS,
    SHAPES
} from './constants';
import './index.scss';

const Avatar = ({
    src,
    className,
    size,
    shape,
    username,
    color
}) => {
    const figureClasses = classNames(BASE_CLASSES_FIGURE, className, `fit-avatar-${shape}-shape`);
    const colorBackgroungClasses = classNames({ [WHITE_FONT_CLASS]: color });

    const style = {
        fontSize: size
    };

    const firstLetter = username[0];

    const backgroundImg = src
        ? { backgroundImage: `url(${src})` }
        : null;

    if (color) {
        style.backgroundColor = color;
    }

    return (
        <figure style={style} className={figureClasses}>
            <figcaption className={colorBackgroungClasses}>{firstLetter}</figcaption>
            <span className={BASE_CLASSES_IMAGE} style={backgroundImg}/>
        </figure>
    );
};

Avatar.propTypes = {
    /**
     * The user's username.
     */
    username: PropTypes.string.isRequired,
    /**
     * The image's source.
     */
    src: PropTypes.string,
    /**
     * The size of the avatar, in pixels.
     */
    size: PropTypes.number,
    /**
     * The shape of the avatar.
     * Supported options are exposed through the static `SHAPES` property.
     */
    shape: PropTypes.oneOf(Object.values(SHAPES)),
    /**
     * The avatar's background color. The letter's color will be white if passed.
     */
    color: PropTypes.string,
    /**
     * Custom classes you wish to pass to the component.
     */
    className: PropTypes.string
};

Avatar.defaultProps = {
    size: 24,
    shape: SHAPES.CIRCLE
};

Object.assign(Avatar, {
    SHAPES
});

export default Avatar;
